export const sizes = {
  icon: {
    small: "1em",
    medium: "1.142em",
    large: "1.71em",
    xlarge: "1.8em",
  },
};
